/**
 * 获取父元素匹配的元素
 * @param {Element} targetNode
 * @param {string} selectorString
 */
export default function getParent(targetNode, selectorString) {
  let current = targetNode.parentElement;
  while (current !== document.body) {
    if (!current) {
      return null;
    }
    if (current.matches(selectorString)) {
      return current;
    } else {
      current = current.parentElement;
    }
  }
  return null;
}

/**
 * 获取父元素匹配的元素的属性值
 * @param {Element} targetNode
 * @param {string} attributeName
 */
export function getParentAttribute(targetNode, attributeName) {
  const matchParent = getParent(targetNode, `[${attributeName}]`);
  if (matchParent) {
    return matchParent.getAttribute(attributeName);
  }
  return null;
}
